function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_47",
  "data-name": "Trazado 47",
  d: "M23.3,9.556v-2.1a1.384,1.384,0,0,0,.81-1.569C23.1,1.551,16.584,0,12.126,0a20.884,20.884,0,0,0-6.76,1.116.474.474,0,1,0,.319.892c.081-.029.163-.057.246-.085l.622,1.708a1.421,1.421,0,0,0,2.671-.972L8.706,1.239c.536-.09,1.084-.161,1.636-.209l.948,2.6a1.421,1.421,0,1,0,2.671-.972L13.351.987c.593.036,1.188.1,1.78.187l.895,2.458A1.421,1.421,0,1,0,18.7,2.659l-.252-.691c1.838.644,4.225,1.895,4.747,4.133a.464.464,0,0,1-.473.532H1.533A.464.464,0,0,1,1.06,6.1,4.494,4.494,0,0,1,2.543,3.753a.474.474,0,1,0-.627-.711A5.42,5.42,0,0,0,.137,5.885,1.384,1.384,0,0,0,.947,7.454v2.1A1.423,1.423,0,0,0,0,10.9a3.32,3.32,0,0,0,3.316,3.316H20.936A3.32,3.32,0,0,0,24.252,10.9a1.423,1.423,0,0,0-.947-1.34ZM8.049,3.59a.474.474,0,0,1-.607-.283l-.6-1.66c.3-.083.611-.158.926-.227l.569,1.563a.475.475,0,0,1-.283.608Zm4.737,0a.474.474,0,0,1-.607-.283L11.326.965c.27-.011.538-.017.8-.017h.2l.74,2.033a.475.475,0,0,1-.283.608Zm4.737,0a.474.474,0,0,1-.607-.283l-.708-1.946c.376.076.744.162,1.1.258l.5,1.364a.475.475,0,0,1-.283.608Zm-.464,5.884L18.954,7.58h3.4V9.474Zm-6.828,1.7L6.638,7.58h7.187ZM1.894,7.58H5.3L7.193,9.474h-5.3Zm13.27,0h2.45l-3.593,3.593L12.8,9.948Zm5.772,5.684H3.315A2.371,2.371,0,0,1,.947,10.9a.474.474,0,0,1,.474-.474H8.14L9.9,12.178a.474.474,0,0,0,.67,0l1.56-1.56,1.56,1.56a.474.474,0,0,0,.67,0l1.756-1.756h6.72a.474.474,0,0,1,.474.474,2.371,2.371,0,0,1-2.368,2.368Zm0,0",
  transform: "translate(0.001 -0.001)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_48",
  "data-name": "Trazado 48",
  d: "M70.947,39.474a.474.474,0,1,0-.474.474A.474.474,0,0,0,70.947,39.474Zm0,0",
  transform: "translate(-66.684 -37.153)",
  fill: "#fff"
});

function SvgSandwich(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sandwich",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.253,
    height: 14.211,
    viewBox: "0 0 24.253 14.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandwich);
export default __webpack_public_path__ + "static/media/sandwich.3609e390.svg";
export { ForwardRef as ReactComponent };